import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { X, ZoomIn, ZoomOut, RotateCcw, Download } from "lucide-react";

const DocumentViewerModal = ({ fileData, onClose }) => {
//   const [zoom, setZoom] = useState(1);
  const [fileUrl, setFileUrl] = useState(null);

  useEffect(() => {
    if (!fileData?.base64) return;

    // ✅ Convert Base64 → Blob
    // const byteCharacters = atob(fileData.base64);
    // const byteNumbers = new Array(byteCharacters.length);

    // for (let i = 0; i < byteCharacters.length; i++) {
    //     byteNumbers[i] = byteCharacters.charCodeAt(i);
    // }

    // const byteArray = new Uint8Array(byteNumbers);
    const byteArray = Uint8Array.from(atob(fileData.base64), (c) =>
      c.charCodeAt(0)
    );
    const blob = new Blob([byteArray], { type: fileData.type });

    const url = URL.createObjectURL(blob);
    setFileUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [fileData]);

  if (!fileData || fileData.type !== "application/pdf") return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center">
      <div className="bg-white dark:bg-[#1e1e1e] rounded-lg shadow-xl w-full max-w-4xl h-[85vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-2 border-b">
          <span className="text-sm font-semibold truncate">
            {fileData.name}
          </span>
          <button onClick={onClose}>
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Toolbar */}
        <div className="flex items-center gap-3 px-4 py-2 border-b bg-gray-50 dark:bg-[#2a2a2a]">
          {/* <button onClick={() => setZoom((z) => Math.min(z + 0.2, 3))}>
            <ZoomIn className="w-5 h-5" />
          </button>

          <button onClick={() => setZoom((z) => Math.max(z - 0.2, 0.5))}>
            <ZoomOut className="w-5 h-5" />
          </button> */}

          {/* <button onClick={() => setZoom(1)}>
            <RotateCcw className="w-5 h-5" />
          </button> */}

          <a href={fileUrl} download={fileData.name} className="ml-auto">
            <Download className="w-5 h-5" />
          </a>
        </div>

        {/* PDF Viewer */}
        <div className="flex-1 overflow-hidden bg-gray-100 dark:bg-black">
          {fileUrl && (
            <embed
              src={fileUrl}
              title="PDF Viewer"
              type="application/pdf"
              className="w-full h-full border-0"
            />
          )}
        </div>
      </div>
    </div>
  );
};

DocumentViewerModal.propTypes = {
  fileData: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["application/pdf"]).isRequired,
    size: PropTypes.number,
    base64: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func.isRequired,
};

export default DocumentViewerModal;
